import jsonp from "jsonp";
import env from "@godweb/frontend-base/src/libs/tools/Environment";

const isIframe = () => {
  return window.top !== window;
};
export default function checkSdc(from = "") {
  const SDC_BASE = "https://auth-ac.my.games/sdc?from=";
  const DEV_SDC_BASE = "https://auth-ac.dev-my.games/sdc?from=";
  const SDC_URL = location.host.includes("dev-my") ? DEV_SDC_BASE : SDC_BASE;
  const url = from ? SDC_URL + from : env.getUrls().sdc;
  if (isIframe()) {
    console.info("checkSdc: iframe context");
    window.location = url;
    return new Promise(() => {});
  } else {
    return new Promise((resolve) => {
      jsonp(url, { param: "JSONP_call", timeout: 1800 }, (err, sdc_response) => {
        if (err) {
          console.info("JSONP error");
          console.info(err);
        }
        resolve(sdc_response);
      });
    });
  }
}
